import * as React from "react";
import "../../assets/crudStyles.css";
import "./styles.css";
import { TextInputCounter } from "../TextInputCounter/TextInputCounter";
import { useParams } from "react-router-dom";
import {
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  ImageInput,
  Toolbar,
  SaveButton,
  useNotify,
  ImageField,
  useRecordContext,
  useDataProvider,
  Edit,
  useGetOne,
  useEditController,
  maxLength,
} from "react-admin";
import { enabledFlags } from "../../constants/utils";
import useFileUpload from "../../hooks/useFileUpload";
import { hexColorRequired } from "../../utils/validators";

const DATAPROVIDER_RESOURCE_ID = "develop-with-us-page-partner-stories";
const RESOURCE_DISPLAY_NAME = "Partner Stories";

interface IEdit {
  [key: string]: any;
}

const EditToolbar = ({ ...props }: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton
        transform={({ ...data }: IEdit) => {
          const date = new Date();

          const mappedRequest: any = {
            ...data,
            // publishedAt: data.enabled == true || data.enabled == "true" ? date.toISOString() : null,
          };

          // Clean up fields.
          delete mappedRequest.imageUpload;
          delete mappedRequest.order;
          delete mappedRequest.id;
          delete mappedRequest.enabled;

          return {
            ...mappedRequest,
          };
        }}
        type="button"
      />
    </Toolbar>
  );
};

export const EditScreen = (props: any) => {
  const { id, onCreated, hasEnabled, resource } = props;
  const notify = useNotify();

  // Record handler.
  const { record } = useEditController(props);

  if (record) {
    record.enabled = record.publishedAt !== null ? true : false;
  }

  return (
    <Edit
      mutationMode="pessimistic"
      resource={resource}
      id={id}
      mutationOptions={{ onSuccess: onCreated }}
      redirect={false}
    >
      <SimpleForm
        toolbar={<EditToolbar record={record} hasEnabled={hasEnabled} />}
        id={id}
        resource={resource}
      >
        <div className="form-text-input-row">
          <TextInputCounter
            formClassName="form-text-input-field"
            source="title"
            validate={[required(), maxLength(100)]}
            limit={100}
          />
          <TextInputCounter
            formClassName="form-text-input-field"
            source="author"
            validate={[required(), maxLength(100)]}
            limit={100}
          />
          {hasEnabled ? (
            <SelectInput
              choices={enabledFlags}
              source="enabled"
              label="Enabled?"
              defaultValue="false"
              validate={[required()]}
            />
          ) : null}
        </div>

        <TextInputCounter
          source="description"
          multiline
          fullWidth
          resettable
          validate={[required(), maxLength(500)]}
          limit={500}
        />
      </SimpleForm>
    </Edit>
  );
};
